var svg = '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m424 64h-88v-16c0-26.51-21.49-48-48-48h-64c-26.51 0-48 21.49-48 48v16h-88c-22.091 0-40 17.909-40 40v32c0 8.837 7.163 16 16 16h384c8.837 0 16-7.163 16-16v-32c0-22.091-17.909-40-40-40zm-216-16c0-8.82 7.18-16 16-16h64c8.82 0 16 7.18 16 16v16h-96z"></path><path d="m78.364 184c-2.855 0-5.13 2.386-4.994 5.238l13.2 277.042c1.22 25.64 22.28 45.72 47.94 45.72h242.98c25.66 0 46.72-20.08 47.94-45.72l13.2-277.042c.136-2.852-2.139-5.238-4.994-5.238zm241.636 40c0-8.84 7.16-16 16-16s16 7.16 16 16v208c0 8.84-7.16 16-16 16s-16-7.16-16-16zm-80 0c0-8.84 7.16-16 16-16s16 7.16 16 16v208c0 8.84-7.16 16-16 16s-16-7.16-16-16zm-80 0c0-8.84 7.16-16 16-16s16 7.16 16 16v208c0 8.84-7.16 16-16 16s-16-7.16-16-16z"></path></g></svg>';
 var lock_svg = '<svg id="lock-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path d="M0 0h24v24H0z" fill="none"></path><path d="M18 8h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2V7a6 6 0 1 1 12 0v1zm-7 7.732V18h2v-2.268a2 2 0 1 0-2 0zM16 8V7a4 4 0 1 0-8 0v1h8z"></path></g></svg>';
 var truck = '<svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path></svg>';
 var coup = '<div id="chpuichec" class="upcart-savings-row styles_Footer__savings__lPeZe"><div class="styles_Footer__savingsCodes__NUySe"><span class="UpcartDesignSettings__cartTextColor">Discounts</span><div class="styles_Footer__slidingCodes__KWveV"><div class="upcart-discount-code-badge DiscountCodeBadge_discountBadge__jEQg8"><div class="upcart-discount-code-icon DiscountCodeBadge_icon__lfykU"><svg viewBox="0 0 20 20"><path d="M13 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path fill-rule="evenodd" d="M11.276 3.5a3.75 3.75 0 0 0-2.701 1.149l-4.254 4.417a2.75 2.75 0 0 0 .036 3.852l2.898 2.898a2.5 2.5 0 0 0 3.502.033l4.747-4.571a3.25 3.25 0 0 0 .996-2.341v-2.187a3.25 3.25 0 0 0-3.25-3.25h-1.974Zm-1.62 2.19a2.25 2.25 0 0 1 1.62-.69h1.974c.966 0 1.75.784 1.75 1.75v2.187c0 .475-.194.93-.536 1.26l-4.747 4.572a1 1 0 0 1-1.401-.014l-2.898-2.898a1.25 1.25 0 0 1-.016-1.75l4.253-4.418Z"></path></svg></div><span class="upcart-discount-code-text DiscountCodeBadge_title__vl5H6">VIP Discount</span></div></div></div><span class="upcart-savings-amount UpcartDesignSettings__cartTextColor">- <span class="money">$9</span></span></div>';
document.addEventListener("DOMContentLoaded", function() {
    
  setTimeout(function(){
    if (typeof current_p_id !== 'undefined'){
    if(jQuery("#hulkapps_custom_options_"+current_p_id).children().length > 0 && jQuery("div[data-parent-id='494465']").length > 0 || jQuery("#hulkapps_custom_options_"+current_p_id).children().length > 0 && jQuery("div[data-parent-id='494462']").length > 0){
      jQuery("#product-options_custom").show();
      var i = 0;
      var html = '';
      jQuery(".hulkapps_option.multiswatch_render").eq(0).children().find(".hulkapps_mswatch_option").each(function(){
          html += '<option data-img="'+ jQuery(this).children().find('.swatch_checkbox ').attr('data-image')+'" data-id="'+i+'">'+jQuery(this).children().find('.hulkapps_option_child').eq(0).attr('value') + '</option>';
          i++;
      });
        jQuery(".custom-opt_box").eq(0).append(html);
        jQuery(".custom-opt_box").eq(0).addClass('custom-selected');

        var html = '';
    jQuery(".hulkapps_option.multiswatch_render").eq(1).children().find(".hulkapps_mswatch_option").each(function(){
        html += '<option data-img="'+ jQuery(this).children().find('.swatch_checkbox ').attr('data-image')+'" data-id="'+i+'">'+jQuery(this).children().find('.hulkapps_option_child').eq(0).attr('value') + '</option>';
        i++;
    });
        jQuery(".custom-opt_box").eq(1).append(html);


        if($('input[name="Color"]:checked').val() == 'Gold'){
            jQuery(".custom-opt_box").eq(0).addClass('custom-selected').removeClass('custom-hidden');
            jQuery(".custom-opt_box").eq(1).addClass('custom-hidden').removeClass('custom-selected');

                jQuery(".custom-opt_box").eq(0).val($(".custom-opt_box.custom-selected option:first").val());
        jQuery(".swatch_checkbox.hulkapps_option_child").eq(jQuery(".custom-opt_box.custom-selected option:first").data('id')).trigger('click');
        jQuery(".custom-opt_box.custom-selected").trigger('change');


        }else{
            jQuery(".custom-opt_box").eq(0).addClass('custom-hidden').removeClass('custom-selected');
            jQuery(".custom-opt_box").eq(1).addClass('custom-selected').removeClass('custom-hidden');
          jQuery(".custom-opt_box").eq(1).val($(".custom-opt_box.custom-selected option:first").val());
        jQuery(".swatch_checkbox.hulkapps_option_child").eq(jQuery(".custom-opt_box.custom-selected option:first").data('id')).trigger('click');console.log('kjsdhf');
        jQuery(".custom-opt_box.custom-selected").trigger('change');
        }
    
    }else{
      
    	jQuery("#product-options_custom").hide();
      jQuery("#hulkapps_custom_options_"+current_p_id).css({
        visibility: "visible",
        height : "100%"
      });

    }
    }
  //  alert(jQuery('.upcart-products-section').length);
if(jQuery('.mydivhai').length === 0 && jQuery('.upcart-products-section').length > 0){
   var process = '<div id="upcartRewards"><div class="upcart-rewardsMessage mydivhai"><p>You`re <span class="moneys">$31</span> away from <strong>FREE SHIPPING</strong></p></div><div class="upcart-rewards-barBackground"><div class="upcart-rewards-barForeground" style="width:52.5%;"></div></div><div class="TieredRewards one"><div></div><div class="upcart-rewardsTier one"><div class="upcart-rewards-tierCircle one" style=" background-color: rgb(20, 21, 22); fill: rgb(226, 226, 226);"><div class="upcart-rewards-tierIcon"> <svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path></svg></div></div><div class="upcart-rewards-tierDescription">Free Shipping</div></div><div class="upcart-rewardsTier two"><div class="upcart-rewards-tierCircle two"><div class="upcart-rewards-tierIcon"> <svg viewBox="0 0 20 20"><path d="M13 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path fill-rule="evenodd" d="M11.276 3.5a3.75 3.75 0 0 0-2.701 1.149l-4.254 4.417a2.75 2.75 0 0 0 .036 3.852l2.898 2.898a2.5 2.5 0 0 0 3.502.033l4.747-4.571a3.25 3.25 0 0 0 .996-2.341v-2.187a3.25 3.25 0 0 0-3.25-3.25h-1.974Zm-1.62 2.19a2.25 2.25 0 0 1 1.62-.69h1.974c.966 0 1.75.784 1.75 1.75v2.187c0 .475-.194.93-.536 1.26l-4.747 4.572a1 1 0 0 1-1.401-.014l-2.898-2.898a1.25 1.25 0 0 1-.016-1.75l4.253-4.418Z"></path></svg></div></div><div class="upcart-rewards-tierDescription">5% Off</div></div></div></div>';  
//alert(jQuery('.upcart-products-section').length);
   jQuery(process).insertBefore('.upcart-products-section');

}

  },3000);
    

function itemspriceupdate(cart){
          var its = 1;
      var total_amount = 0;
  for (const item of cart.items) {
   // console.log(cart.items);
      var total = 0;
 
    jQuery.each(item.properties, function(key, value){
       let priceText = value.split(',');
jQuery.each(priceText, function( index, values ) {
  var checkp = values.replace(/[^0-9\.]/gi, '');
  if(jQuery.isNumeric(checkp)) {
     total += parseFloat(checkp);
  }
});
    });
jQuery('.upcart-products-section .upcart-product-item:nth-child('+its+') .Stack__item.Stack__item--fill .Stack--noWrap .Stack__item:nth-child(2) .upcart-item-price span.money').each(function(){
jQuery(this).html("$"+(((total * item.quantity) + parseFloat(item.final_line_price / 100)) - Math.round(item.total_discount/100)));  
});
    its += 1;
     //console.log(item.title+"----"+((total * item.quantity) + parseFloat(item.final_line_price / 100)));
    total_amount += ((total * item.quantity) + parseFloat(item.final_line_price / 100));
  //  console.log(total_amount);
    }
   setTimeout(function(){
  if(jQuery('.mydivhai').length === 0){
       var processs = '<div id="upcartRewards"><div class="upcart-rewardsMessage mydivhai"><p>You`re <span class="moneys">$31</span> away from <strong>FREE SHIPPING</strong></p></div><div class="upcart-rewards-barBackground"><div class="upcart-rewards-barForeground" style="width:52.5%;"></div></div><div class="TieredRewards one"><div></div><div class="upcart-rewardsTier one"><div class="upcart-rewards-tierCircle one" style=" background-color: rgb(20, 21, 22); fill: rgb(226, 226, 226);"><div class="upcart-rewards-tierIcon"> <svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path></svg></div></div><div class="upcart-rewards-tierDescription">Free Shipping</div></div><div class="upcart-rewardsTier two"><div class="upcart-rewards-tierCircle two"><div class="upcart-rewards-tierIcon"> <svg viewBox="0 0 20 20"><path d="M13 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path fill-rule="evenodd" d="M11.276 3.5a3.75 3.75 0 0 0-2.701 1.149l-4.254 4.417a2.75 2.75 0 0 0 .036 3.852l2.898 2.898a2.5 2.5 0 0 0 3.502.033l4.747-4.571a3.25 3.25 0 0 0 .996-2.341v-2.187a3.25 3.25 0 0 0-3.25-3.25h-1.974Zm-1.62 2.19a2.25 2.25 0 0 1 1.62-.69h1.974c.966 0 1.75.784 1.75 1.75v2.187c0 .475-.194.93-.536 1.26l-4.747 4.572a1 1 0 0 1-1.401-.014l-2.898-2.898a1.25 1.25 0 0 1-.016-1.75l4.253-4.418Z"></path></svg></div></div><div class="upcart-rewards-tierDescription">5% Off</div></div></div></div>';  
       jQuery(processs).insertBefore('.upcart-products-section');
     }
     if(total_amount < 100){
        var barpercentage =  ((total_amount)/200)*100;
     jQuery('.upcart-rewards-barForeground').css("width",barpercentage+"%");
       var ams = 100 - total_amount;
    jQuery('.upcart-rewards-tierCircle.one,.upcart-rewards-tierCircle.two').css({'background-color': 'transparent','fill': '#000'})
jQuery('#chpuichec').hide();
   
       jQuery('.upcart-rewardsMessage > p').html(`You’re <span class="moneys">$`+ams+`</span> away from <strong>FREE SHIPPING</strong>`);
     }
     if(total_amount >= 100 && total_amount < 125){
        var barpercentage =  ((total_amount)/125)*100;
     jQuery('.upcart-rewards-barForeground').css("width",barpercentage+"%");
jQuery('.upcart-rewards-tierCircle.two').css({'background-color': 'transparent','fill': '#000'})
jQuery('#chpuichec').hide();
    jQuery('.upcart-rewards-tierCircle.one').css({'background-color': 'rgb(20, 21, 22)','fill': 'rgb(226, 226, 226)'})
       var ams =  125 - total_amount;
       jQuery('.upcart-rewardsMessage > p').html(`You’re <span class="money">$`+ams+`</span> away from <strong >5% off your entire cart!</span>`);
     }
if(total_amount > 125){
   var barpercentage =  ((total_amount)/125)*100;
     jQuery('.upcart-rewards-barForeground').css("width",barpercentage+"%");
      jQuery('.upcart-rewards-tierCircle.one,.upcart-rewards-tierCircle.two').css({'background-color': 'rgb(20, 21, 22)','fill': 'rgb(226, 226, 226)'})
if(jQuery('#chpuichec').length === 0){
  jQuery(coup).insertBefore('.styles_Footer__checkoutButton__kdn9J');
    jQuery('#chpuichec').css('display','flex');
}else{
  jQuery('#chpuichec').css('display','flex');
}
   
       jQuery('.upcart-rewardsMessage > p').html(`<strong>FREE SHIPPING</strong> <strong>UNLOCKED!</strong>`);
}
   //  console.log(jQuery('.mydivhai').length+" check length");
   

   },1000);
    }
// window.upcartOnAddToCart = (cart) => {
//   itemspriceupdate(cart);
// }
window.upcartOnCartLoaded = (cart) => {
itemspriceupdate(cart);
    var loaderElement = $('<div>').addClass('checkout-loader');

var checkoutButton =  jQuery(".upcart-checkout-button");
    
checkoutButton.after(loaderElement); jQuery(".checkout-loader").hide();
    var cartButton = document.querySelector(".styles_Footer__checkoutButton__kdn9J");
  var btnhtml = jQuery(".upcart-checkout-button").html();
    if(cartButton){
      cartButton.disabled = true;
    }
  
 jQuery(".checkout-loader").show();
    if (jQuery(".checkout-hulk-btn-custom").length == 0) {
     // console.log(btnhtml);
      jQuery(".upcart-checkout-button").after('<a href="javascript:void(0)" class="checkout-hulk-btn-custom">'+ btnhtml +'</a>');
    }
   // jQuery('.upcart-express-pay-buttons-container').insertAfter('.styles_Footer__checkoutButton__kdn9J');

setTimeout(function() {
      console.log("here"); 

jQuery(".checkout-loader").hide(); 
    if(cartButton){cartButton.disabled = false;}
  }, 3000);
jQuery('.upcart-rewards-tier.styles_TieredRewards__tierCircleAndDescription__AhLjz.styles_TieredRewards__tierCircleAndDescription--exactlyCenter__8D9zz .upcart-rewards-tier-icon').html(truck);
}

window.upcartOnCartUpdated = (cart) => {
    itemspriceupdate(cart);
    var cartButton = document.querySelector(".styles_Footer__checkoutButton__kdn9J");
 jQuery(".checkout-loader").show();
cartButton.disabled = true;
  var btnhtml = jQuery(".upcart-checkout-button").html();
    jQuery(".checkout-hulk-btn-custom").html(lock_svg + "Checkout • <span data-hulkapps-cart-total>"+ Shopify.formatMoney(cart.total_price, '${{amount_no_decimals}}') +"</span>");
 // jQuery('.upcart-express-pay-buttons-container').insertAfter('.styles_Footer__checkoutButton__kdn9J');
  setTimeout(function() {
cartButton.disabled = false;
 jQuery(".checkout-loader").hide();

  }, 3000);
jQuery('.upcart-rewards-tier.styles_TieredRewards__tierCircleAndDescription__AhLjz.styles_TieredRewards__tierCircleAndDescription--exactlyCenter__8D9zz .upcart-rewards-tier-icon').html(truck);
}


  });


  jQuery(document).on("click", ".checkout-hulk-btn-custom", function (i) {
      if ((i.preventDefault(), window.hulk_inventory_arr && window.hulk_inventory_arr.length > 0)) {
          var e = '<div class="hulkapps_summary inventory_validation_hulkapps">';
          return (
              window.hulk_inventory_arr.forEach(function (t) {
                  e += t;
              }),
              (e += "</div>"),
              jQuery(".inventory_validation_hulkapps").remove(),
              jQuery(this).parent().after(e),
              !1
          );
      }
      if ((jQuery(".inventory_validation_hulkapps").remove(), window.is_draft_order && window.hulk_inventory_arr && window.hulk_inventory_arr.length <= 0))
          if (("function" != typeof hulkappsCheckout && (window.location = "/checkout"), "undefined" == typeof hulkappsCheckoutClick)) hulkappsCheckout(null);
          else {
              var o = hulkappsCheckoutClick();
              1 == o.required ? hulkappsCheckout(o) : 0 != o.required && hulkappsCheckout(o);
          }
      else window.location = "/checkout";
  });
  
  

  
jQuery(document).on('change','input[name=Color]',function(){
	jQuery(".swatch_selected").children('input.swatch_checkbox.hulkapps_option_child').trigger('click');
  jQuery("#selected-items-list").empty();
  jQuery("#hlk-custom_total").empty();
  if($('input[name="Color"]:checked').val() == 'Gold'){
    	jQuery(".custom-opt_box").eq(0).addClass('custom-selected').removeClass('custom-hidden');
      	jQuery(".custom-opt_box").eq(1).addClass('custom-hidden').removeClass('custom-selected');
		
        jQuery(".custom-opt_box.custom-selected").val($(".custom-opt_box.custom-selected option:first").val());
          jQuery(".hulkapps_mswatch_option").eq(jQuery(".custom-opt_box.custom-selected option:first").data('id')).trigger('click');
          jQuery(".custom-opt_box").eq(0).trigger('change');

      
    }else{
    	jQuery(".custom-opt_box").eq(0).addClass('custom-hidden').removeClass('custom-selected');
      	jQuery(".custom-opt_box").eq(1).addClass('custom-selected').removeClass('custom-hidden');
      jQuery(".custom-opt_box.custom-selected").val($(".custom-opt_box.custom-selected option:first").val());
    jQuery(".hulkapps_mswatch_option").eq(jQuery(".custom-opt_box.custom-selected option:first").data('id')).trigger('click');
    jQuery(".custom-opt_box").eq(1).trigger('change');
    }

});

  function triggeroption_select(el){
  	jQuery(".swatch_checkbox.hulkapps_option_child").eq(jQuery(el).find(':selected').data('id')).parent().trigger('click');
    jQuery(".img-box").attr('src',jQuery(el).find(':selected').data('img'));
    jQuery(".img-box").show();
    
    if(jQuery("#selected-items-list").children().length == 0){
      jQuery(".selected-items-list").hide();
    }                                
    if(jQuery(el).find(':selected').data('id') !='0' && jQuery(el).find(':selected').data('id') !='42'){
      
  		jQuery(".selected-items-list").show();
  		if(jQuery("#itemid_"+jQuery(el).find(':selected').data('id')).length == 0){
      		jQuery("#selected-items-list").append('<li id="itemid_'+jQuery(el).find(':selected').data('id')+'"><img class="img-box-selected" src="'+jQuery(el).find(':selected').data('img')+'"><p class="selected-item-name">'+jQuery(el).find(':selected').html()+'<span onclick="removeitem('+jQuery(el).find(':selected').data('id')+',this)">'+svg+'</span></p></li>');
    
        }else{
        	jQuery("#itemid_"+jQuery(el).find(':selected').data('id')).remove();
        }
      setTimeout(function(){
        console.log(jQuery('#option_total').html());
        jQuery("#hlk-custom_total").html(jQuery('#option_total').html());
        jQuery("#hlk-custom_total").children().eq(1).children().eq(0).children().eq(0).html(parseInt(jQuery("#hlk-custom_total").children().eq(1).children().eq(0).children().eq(0).html()));
        if(jQuery("#hlk-custom_total").hasClass('hide')){jQuery("#hlk-custom_total").removeClass('hide');}
      },1000);
       setTimeout(function(){
      var prices = 0;
      jQuery('.hulkapps_option_value label input[type="checkbox"]:checked').each(function(){
          prices += parseInt(jQuery(this).attr('data-price'));
        jQuery(this).trigger('click');
  jQuery(this).trigger('click');
      });
      jQuery('span#formatted_option_total span#calculated_option_total').html(prices);
},1200);
    }
    
  }

function removeitem(id,el){
	jQuery(".swatch_checkbox.hulkapps_option_child").eq(id).trigger('click');
	setTimeout(function(){
        jQuery("#hlk-custom_total").html(jQuery('#option_total').html());
        jQuery("#hlk-custom_total").children().eq(1).children().eq(0).children().eq(0).html(parseInt(jQuery("#hlk-custom_total").children().eq(1).children().eq(0).children().eq(0).html()));
        if(jQuery("#hlk-custom_total").hasClass('hide')){jQuery("#hlk-custom_total").removeClass('hide');}
      },1000);
  	jQuery(el).parent().parent().remove();
  	jQuery(".custom-opt_box.custom-selected").val($(".custom-opt_box.custom-selected option:first").val());
  jQuery(".custom-opt_box.custom-selected").trigger('change');
  if(jQuery("#selected-items-list").children().length == 0){
  	jQuery(".selected-items-list").hide();
  }
}


if(jQuery(".property_value").length > 0){
  jQuery(".property_value").each(function(){
      
          jQuery(this).html(jQuery(this).html().replaceAll('.00',''));
      
  });
}
 